// Legacy / duplicate URLs → canonical public URL. Handled by ONE catch-all route so
// none of these paths is registered as a separate public page. Keys are lowercase.
export const LEGACY_REDIRECTS = {
  '/index.html': '/',
  '/home': '/',
  '/heritage': '/atelier#theodore',
  '/innovations': '/',
  '/innovation': '/',
  '/social-responcibility': '/atelier/impact',
  '/social-responsibility': '/atelier/impact',
  '/articles': '/journal',
  '/impact': '/atelier/impact',
  '/team': '/atelier/team',
  '/editor': '/admin/editor',
  '/builder': '/admin/builder',
  '/balayage': '/balayage-chalandri',
  '/mpalage-chalandri': '/balayage-chalandri',
  '/balalias-chalandri': '/balayage-chalandri',
  '/μπαλαγιαζ-χαλανδρι': '/balayage-chalandri',
  '/μπαλαλιάς-χαλάνδρι': '/balayage-chalandri',
  '/keratini': '/keratin-treatment-chalandri',
  // Near-duplicate URLs consolidated into one canonical page each
  '/baby-lights-chalandri': '/babylights-chalandri',
  '/poso-kostizei-balayage-athina-2026': '/poso-kostizei-balayage-2026',
  '/ai-axiologisi-mallion': '/services/face-metrics-pro',
  '/face-metrics-pro-experience': '/services/face-metrics-pro',
  '/koureima-ikonomakis': '/womens-haircut-chalandri',
  // Corrupted slug (Arabic 'ما' instead of 'ma') → repaired slug
  '/ai-analysi-prosopou-koureما-xroma': '/ai-analysi-prosopou-kourema-xroma',
  // Old ASP site (pre-2020) — indexed article viewer URL
  '/new/viewarticle.asp': '/journal',
  '/new': '/',
  // Internal component paths that leaked into the index
  '/home-atelier': '/',
  '/smartslugrouter': '/',
  '/home/homepage': '/',
  '/home/sitenav': '/',
  // Old Wix pages
  '/booking-policy': '/faq',
  '/memberclub': '/',
  '/about-3': '/atelier',
  '/copy-of-restia': '/services/hair-treatments',
  '/copy-of-k18-1': '/k18-hair-treatment-chalandri',
  '/copy-of-κ18-βιομημιτική-θεραπεία': '/k18-hair-treatment-chalandri',
  '/copy-of-donate-hair-donate-love': '/atelier/impact',
  '/copy-of-haircg-tv': '/press',
  // Old article/service URLs → current canonical pages
  '/celebrity-hairdresser-athens': '/best-hair-salon-athens',
  '/qiqi-vega-hair-treatment': '/keratin-treatment-chalandri',
  '/milbon-360o-japanese-therapy-ikonomakis': '/milbon-360-chalandri',
  '/kourema-gia-lepta-mallia': '/precision-haircut-chalandri',
  '/o-theodoros-oikonomakis-parousiazei-to-olaplex-sto-proino-ant1-mesa-apo-ta': '/press',
  // Corrupted / misspelled slugs (mixed alphabets from the old export)
  '/pos-i-texniti-noimosyni-vrisket-to-kourema': '/pos-i-texniti-noimosini-vrisket-to-kourema',
  '/posо-sychna-syntiritisi-xantho': '/poso-sychna-syntiritisi-xantho',
  '/ai-analysi-prosopou-koureμα-xroma': '/ai-analysi-prosopou-kourema-xroma',
  // Duplicate area / "best-" / "premium-" variants consolidated: 1 topic = 1 URL
  '/hair-salon-filothei': '/kommotirio-voreia-proastia',
  '/hair-salon-psychiko': '/kommotirio-voreia-proastia',
  '/hair-salon-chalandri': '/kommotirio-chalandri',
  '/best-hair-salon-chalandri': '/kommotirio-chalandri',
  '/hair-salon-northern-suburbs-athens': '/kommotirio-voreia-proastia',
  '/best-hair-salons-northern-suburbs': '/kommotirio-voreia-proastia',
  '/premium-hair-salon-athens': '/best-hair-salon-athens',
  '/premium-gynaikeio-kourema-athens': '/gynaikeio-kourema-athens',
  '/ai-hair-consultation-athens': '/hair-consultation-athens',
  // 404s from old site structure and leaked component paths
  '/teampage': '/atelier/team',
  '/visualbuilder': '/',
  '/pageeditor': '/',
  '/socialimpactpage': '/atelier/impact',
  '/portfolio': '/gallery',
  '/portfolio-1': '/gallery',
  '/3dtour': '/atelier',
  '/hcg-beautycrew-tv': '/press',
  '/matrix': '/services/hair-treatments',
  '/products': '/',
  '/product-page': '/',
  '/service-page': '/services',
  '/kerastase-boucles-d-art-150ml': '/',
  '/4-hairstyles-gia-to-gumnastirio': '/journal',
  '/painting-h-texni-toy-balayage-hot-tasi-sto-xroma-gia-to-2016': '/ti-einai-to-balayage',
  // Search Console coverage report (2026-09-23) — URLs that still fell through to 404
  '/homeatelier': '/',
  '/journalindex': '/journal',
  '/blogarticlepage': '/journal',
  '/copy-of-κ18-βιομιμητική-θεραπεία': '/k18-hair-treatment-chalandri',
  '/ai-analysi-prosopou-koureμa-xroma': '/ai-analysi-prosopou-kourema-xroma',
  '/post': '/journal',
  '/blogs': '/journal',
  '/book-online': '/contact',
  '/about-1': '/atelier',
  '/hair': '/services',
  '/essie': '/',
  '/keune': '/',
  '/giati-mas-aressie-agapimena-mankiour-me-tis-pio-hot-apoxrwseis-tis-essie': '/journal',
  '/dirty-blonde-h-tasi-gia-to-apolito-ksantho-2015': '/blonde-specialist-chalandri',
  '/nifika-xtenismata-gia-oses-theloun-na-foresoun-peplo': '/journal',
  '/sneakers-stylistikes-protaseis-gia-tin-anoi3i-2016': '/journal',
  '/babylike-hair-hot-trend-2016': '/services/babylights',
  '/sun-kissed-hightlights-mallia-filimena-apo-ton-ilio-color-trends-2015': '/ti-einai-to-balayage',
  '/rouge-allios': '/journal',
  // Old English Wix pages → current equivalents
  '/en/faq': '/faq',
  '/en/balayage': '/en/balayage-athens',
  '/en/reviews': '/reviews',
  '/en/babylights': '/en/babylights-athens',
  '/en/keratin': '/en/hair-treatments-athens',
  '/en/airtouch': '/en/airtouch-athens',
  '/en/haircut': '/en/haircuts-athens',
  '/en/contact': '/contact',
  '/en/book-online': '/contact',
};

// Legacy path prefixes from the old site (profiles, blog hashtags, Shopify checkouts) → canonical
const LEGACY_PREFIXES = [
  ['/profile/', '/atelier/team'],
  ['/ikonomakisblog', '/journal'],
  ['/new/', '/'],
  ['/29649158/', '/'],
  // Old Wix multilingual trees (never had Greek content worth keeping)
  ['/es', '/'],
  ['/fr', '/'],
  ['/de', '/'],
  ['/en/product-page', '/'],
  ['/en/copy-of-', '/'],
  ['/en/service-page', '/services'],
  // Old e-shop / product catalogue (shop no longer exists)
  ['/eshop', '/'],
  ['/collections', '/'],
  ['/products/', '/'],
  ['/product-page', '/'],
  ['/category', '/'],
  ['/redken', '/services/hair-treatments'],
  ['/styling-tools', '/'],
  ['/hair/', '/services'],
  // Old Wix blog
  ['/post/', '/journal'],
  ['/home/', '/'],
  ['/blogs/', '/journal'],
  ['/service-page/', '/hair-consultation-athens'],
  ['/keune/', '/'],
  ['/matrix/', '/services/hair-treatments'],
  ['/assets/', '/'],
  // Any other old /en/* Wix page (real /en routes match before the catch-all)
  ['/en/', '/en'],
];

// Returns the canonical target for a legacy path, or null when the path is current.
export function resolveLegacyPath(pathname) {
  let path = pathname;
  try { path = decodeURIComponent(pathname); } catch { /* keep raw */ }
  path = path.replace(/\/+$/, '') || '/';
  const lower = path.toLowerCase();

  if (LEGACY_REDIRECTS[lower]) return LEGACY_REDIRECTS[lower];
  // Prefixes ending in "/" or "-" match as-is; bare prefixes (/fr, /eshop …) match only a whole
  // path segment — so /fr never swallows real slugs like /frizarisma-… or /de… articles.
  for (const [prefix, target] of LEGACY_PREFIXES) {
    const open = prefix.endsWith('/') || prefix.endsWith('-');
    if (open ? lower.startsWith(prefix) : (lower === prefix || lower.startsWith(`${prefix}/`))) return target;
  }
  if (lower.startsWith('/journal/')) return lower.slice('/journal'.length);
  if (lower.startsWith('/atelier-preview')) return lower.slice('/atelier-preview'.length) || '/';
  if (lower.startsWith('/article/')) return '/';
  // Uppercase duplicates (/Services, /Journal, /FAQ …) → lowercase canonical form
  if (lower !== path) return lower;
  return null;
}